angular.module('picmonicng').directive('plsMenuPlayerAudioSpeed', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/pls-menu-player-audio-speed.html',
      controller: [
        '$scope',
        'LearnService',
        'UserService',
        function ($scope, LearnService, UserService) {
          $scope.LearnService = LearnService;
          $scope.UserService = UserService;
        },
      ],
    };
  },
]);
